import { render, staticRenderFns } from "./page_sort.vue?vue&type=template&id=ed2bb458&scoped=true&"
import script from "./page_sort.vue?vue&type=script&lang=js&"
export * from "./page_sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2bb458",
  null
  
)

export default component.exports